import type { MangoApiClient } from '@mangovoice/mango-api-client'

export interface AiConfigApiClient {
  transport: MangoApiClient['aiConfiguration']
}

/**
 * Creates an AiConfigApiClient from a transport adapter.
 * Pass the returned client to query hooks.
 */
export function createAiConfigApi(
  transport: MangoApiClient['aiConfiguration'],
): AiConfigApiClient {
  return { transport }
}
